import { TableViewMenu } from './TableViewMenu';
import type { BuyerBoardColumnConfig } from './useBuyerBoardColumnConfig';
import type { HiddenColumns } from './useColumnsHiddenByFilters';

/**
 * The Orders table's view menu: the column setup, and the columns a filter
 * narrowed to one value.
 */
export function OrdersViewMenu({
  columns,
  config,
}: {
  columns: HiddenColumns;
  config: BuyerBoardColumnConfig;
}) {
  return (
    <TableViewMenu
      view={{ columns, config }}
      className="ml-auto h-6"
      columnLabels={Object.fromEntries(
        config.columns.map((column) => [column.id, column.header]),
      )}
    />
  );
}
